import missingImage from "webutils/imgs/image-coming-soon.jpg";
//const COMING_SOON = '//emuncloud-staticassets.s3.amazonaws.com/photo_cmg_soon.jpg';

export default ($timeout, $parse) => ({
  restrict: "A",
  link(scope, element, attrs) {
    let attempts = 0;
    let index = 0;
    let uSrc = attrs.src;
    let orgSrc = attrs.ngSrc || uSrc;
    let errSrc =
      attrs.onerrorSrc ||
      "https://dummyimage.com/500x500/fff/333?text=Loading...";
    let errDelay = parseInt(attrs.onerrorDelay || 3000);
    let errRetries = parseInt(attrs.onerrorRetries || 0);
    let reloadEvent =
      attrs.imagePollerReload ||
      attrs.reloadEvent ||
      attrs.alternateImageReload ||
      attrs.reload;
    let alternateImages = attrs.alternateImages
      ? scope.$eval(attrs.alternateImages)
      : attrs.altImages
      ? scope.$eval(attrs.altImages)
      : [attrs.alternateImage || attrs.altImage || missingImage];
    let alternateImageTitle =
      attrs.alternateImageTitle ||
      attrs.altImageTitle ||
      attrs.altTitle ||
      "This image is coming soon!";
    const $altIndex = $parse(attrs.altIndex || "altIndex");
    if (!Array.isArray(alternateImages)) alternateImages = [];
    //console.debug('alt imgs', { scope, element, attrs, alternateImages, uSrc, orgSrc, errSrc });
    if (uSrc == undefined || uSrc == "undefined") {
      uSrc = orgSrc;
    }
    if (reloadEvent) {
      scope.$on(reloadEvent, (e, newSrc, delay) => {
        element.attr({ src: uSrc || orgSrc });
        let reloadUrl = newSrc || orgSrc || ""; //.replace(/https?:/gi, '');
        let concatenator = reloadUrl.indexOf("?") > 0 ? "&" : "?";
        reloadUrl += `${concatenator}${new Date().getTime()}=no-cache`;
        $timeout(() => element.attr({ src: reloadUrl }), delay || errDelay);
      });
    }
    element.on("error", function errorHandler() {
      if (index < alternateImages.length) {
        if (alternateImages[index] === "hide") {
          element.hide();
        } else {
          //console.warn('alternateImages... ', index, { index, altImg: alternateImages[index], alternateImages });
          element.attr({
            src: alternateImages[index],
            alt: alternateImageTitle,
          });
          $altIndex.assign(scope, index);
          index++;
        }
      } else {
        element.attr({
          src: errSrc,
          alt: alternateImageTitle,
        });
        //console.warn('errSrc... ', errSrc);
        if (attempts++ <= errRetries) {
          //console.warn('waiting... ', attempts);
          $timeout(() => {
            //console.warn('retrying... ', orgSrc);
            index = 0;
            element.attr({
              src: orgSrc,
              alt: attrs.title,
            });
          }, errDelay);
        }
      }
    });
  },
});
